import { useEffect, useState } from 'react'
import NoResultsContainer from '../NoResults/NoResults'
import { useSelector } from 'react-redux';
import { useGroupStudentsContext } from '../GroupStudentsContext/GroupStudentsContext';
import Loading from '../../../../../Loading/Loading';
import StudentDistributionTable from './Table';
import DialogStudentDistribution from './Dialog';

const StudentDistribution = () => {
  const { curriculumId, onLoadStudentDistribution, loadingChart, dataChart } = useGroupStudentsContext();
  const state = useSelector((state) => state?.filter?.groupStudents || {});
  const [modal, setModal] = useState(null);

    useEffect(() => {
    if (curriculumId) {
      onLoadStudentDistribution(curriculumId, state.filter);
    }
  }, [curriculumId, state.filter]);

  return (
    <>
      {loadingChart ? (
        <Loading />
      ) : dataChart?.data?.length > 0 ? (
          <StudentDistributionTable 
          levelsData={dataChart?.levels || []} 
          lcs={dataChart?.data || []} 
          students={dataChart?.students || 0}
          onClickStudent={(formData) => setModal({ show: true, formData })}
        />
      ) : (
        <NoResultsContainer />
      )}
      {modal && (
        <DialogStudentDistribution
          show={modal?.show}
          onClose={() => setModal(null)}
          formData={modal?.formData || {}}
        />
      )}
    </>
  )
}

export default StudentDistribution